<script lang="ts">
    import {_} from 'svelte-i18n'
    import {mySession} from './services';
    import Textfield from '@smui/textfield';
    import HelperText from '@smui/textfield/helper-text';
    import Button from '@smui/button';
    import {Label} from '@smui/common';

    const USERNAME_REGEX = /^([1-9a-záčďéěíňóřšťúůýžA-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ])([1-9a-záčďéěíňóřšťúůýžA-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ ]*)$/;
    const USERNAME_MAX_LENGTH = 20;
    const USERNAME_HELPER_TEXT_LENGTH_THRESHOLD = USERNAME_MAX_LENGTH - 2;

    let username: string = ''

    function submit() {
        if (isValid(username)) {
            mySession.loginClient({username: username.trim()});
        }
    }

    function isValid(username: string) {
        if (!username.match(USERNAME_REGEX)) {
            return false;
        }
        return username.length <= USERNAME_MAX_LENGTH;
    }
</script>

<div style="margin: 20px 0 10px 0; padding: 10px 0">
    <form on:submit|preventDefault={submit} style="display: flex; flex-direction: row; align-items: center; box-sizing: border-box;">
        <div>
            <Textfield bind:value={username} input$maxlength={USERNAME_MAX_LENGTH} label={$_('user.auth.YourNickname')} input$aria-describedby="client-username-input-helper-text">
                <HelperText slot="helper">
                    {#if username.length >= USERNAME_HELPER_TEXT_LENGTH_THRESHOLD}{$_('validation.MaxXChars', {values: {x: USERNAME_MAX_LENGTH}})}{/if}
                    {#if username.length > 0 && !isValid(username)}{$_('user.auth.NicknameRestrictionMessage')}{/if}
                </HelperText>
            </Textfield>
        </div>
        <div style="margin-left: 10px">
            <Button type="submit" variant="unelevated" disabled={username.length > 0 && !isValid(username)}><Label>{$_('user.auth.LoginSubmit')}</Label></Button>
        </div>
    </form>
</div>